import {Component, HostListener, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subject, Subscription, timer} from 'rxjs';
import {take, takeUntil} from 'rxjs/operators';
import {Router} from '@angular/router';
import {NgbModal, NgbActiveModal} from '../modal/modal.module';

/**
 * A directive that provides indication of the application processing.
 */
@Component({
  selector: 'ngb-timeout',
  template: `<ng-template #timeoutModal let-modal>
      <div class="modal-content">
          <button type="button" class="close" aria-label="Close" (click)="modalService.dismissAll('Cross click')">
              <img src="https://clopay-component-library.s3.us-east-2.amazonaws.com/close-icon-brand.svg" alt=""/>
          </button>
          <div class="modal-header">
              <h5>Inactive Warning</h5>
          </div>
          <div class="modal-body">
              <div class="modal-info">
                  Please confirm that you are active.  Otherwise you will be logged out after two minutes.
              </div>
          </div>
          <div class="modal-footer">
              <button type="button" class="button-secondary" (click)="modalService.dismissAll()">I am here.</button>
          </div>
      </div>
  </ng-template>`,
  styleUrls: ['./timeout.scss']
})
export class NgbdTimeout implements OnDestroy, OnInit {


  constructor(private router: Router,
              public modalService: NgbModal) {
  }
  logoutAfter = 20 * 60 * 1000;   // milliseconds
  warningDuration = 2 * 60 * 1000;   // milliseconds
  debugLogoutAfter = 2 * 60 * 1000;   // milliseconds
  debugWarningDuration = 1 * 60 * 1000;   // milliseconds
  effectiveLogoutAfter: number;
  effectiveWarningDuration: number;

  userActionOccurred: Subject<void> = new Subject();
  unsubscribe$: Subject<void> = new Subject();

  warningTimerSubscription: Subscription;
  logoutTimerSubscription: Subscription;

  modalIsOpen = false;
  @ViewChild('timeoutModal', { static: false }) private timeoutModal;

  @Input() navigationLink: string;
  @Input() oneMinuteDebug: boolean;

  @HostListener('document:keyup')
  @HostListener('document:click')
  @HostListener('document:wheel')
  actionOccurred() {
    this.userActionOccurred.next();
  }

  ngOnInit() {
    if ( this.oneMinuteDebug && this.oneMinuteDebug === true ) {
      this.effectiveLogoutAfter = this.debugLogoutAfter;
      this.effectiveWarningDuration = this.debugWarningDuration;
    } else {
      this.effectiveLogoutAfter = this.logoutAfter;
      this.effectiveWarningDuration = this.warningDuration;
    }

    this.resetTimers();
    this.userActionOccurred.asObservable().pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe(() => {
      if (this.warningTimerSubscription) {
        this.warningTimerSubscription.unsubscribe();
      }
      if (this.logoutTimerSubscription) {
        this.logoutTimerSubscription.unsubscribe();
      }

      this.resetTimers();
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  resetTimers(warningDuration: number = this.effectiveWarningDuration, logoutAfter: number = this.effectiveLogoutAfter) {
    this.warningTimerSubscription = timer( (logoutAfter - warningDuration) ).pipe(
      take(1)
    ).subscribe( value => { }, err => { },
      () => {
        this.open();

        this.logoutTimerSubscription = timer( warningDuration ).pipe(
          take( 1 )
        ).subscribe( value => { }, err => { },
          () => {
            this.modalService.dismissAll();
            console.log('logging out');
            window.dispatchEvent(new Event('logout-event'));
          }
        );

      }
    );
  }

  open() {
    if ( this.modalIsOpen === false ) {
      this.modalService.dismissAll();

      this.modalIsOpen = true;
      this.modalService.open(this.timeoutModal, {windowClass: 'timeoutModal '}).result.then((result) => {
        this.modalIsOpen = false;
      }, (reason) => {
        this.modalIsOpen = false;
      });
    }
  }
}
